/* =====================================================================
   VAIRO REDESIGN — Scroll reveal + accordion + carousel + marquee
   Aplica a las páginas Vairo Padel Center, Distribuidores y Clubes,
   y Pistas Vairo Court.
   ===================================================================== */
(function () {
  'use strict';

  if (typeof window === 'undefined') return;

  const reveal = () => {
    const els = document.querySelectorAll('.v-reveal:not(.is-visible)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const isMobile = window.innerWidth < 750;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: isMobile ? '0px 0px 0px 0px' : '0px 0px -10% 0px', threshold: isMobile ? 0.01 : 0.08 }
    );
    els.forEach((el) => io.observe(el));
  };

  // Marquee duplication para loop sin saltos
  const initMarquee = () => {
    document.querySelectorAll('.v-marquee__track:not([data-cloned])').forEach((track) => {
      const clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-cloned');
      track.parentNode.appendChild(clone);
      track.setAttribute('data-cloned', 'true');
    });
  };

  // Accordion — smooth open/close for <details>
  const initAccordion = () => {
    document.querySelectorAll('.v-accordion__item:not([data-accordion-init])').forEach((details) => {
      details.setAttribute('data-accordion-init', '');
      const summary = details.querySelector('.v-accordion__header');
      const body = details.querySelector('.v-accordion__body');
      if (!summary || !body) return;

      let animation = null;

      summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (animation) animation.cancel();

        if (details.open) {
          // Closing
          const startH = body.offsetHeight;
          body.style.height = startH + 'px';
          body.style.overflow = 'hidden';

          requestAnimationFrame(() => {
            animation = body.animate(
              [{ height: startH + 'px' }, { height: '0px' }],
              { duration: 350, easing: 'cubic-bezier(0.22,1,0.36,1)' }
            );
            animation.onfinish = () => {
              details.open = false;
              body.style.height = '';
              body.style.overflow = '';
              animation = null;
            };
          });
        } else {
          // Opening
          details.open = true;
          const endH = body.scrollHeight;
          body.style.height = '0px';
          body.style.overflow = 'hidden';

          requestAnimationFrame(() => {
            animation = body.animate(
              [{ height: '0px' }, { height: endH + 'px' }],
              { duration: 350, easing: 'cubic-bezier(0.22,1,0.36,1)' }
            );
            animation.onfinish = () => {
              body.style.height = '';
              body.style.overflow = '';
              animation = null;
            };
          });
        }
      });
    });
  };

  // Carousel — scroll-snap indicators + prev/next
  const initCarousel = () => {
    document.querySelectorAll('.v-carousel:not([data-carousel-init])').forEach((carousel) => {
      carousel.setAttribute('data-carousel-init', '');
      const track = carousel.querySelector('.v-carousel__track');
      const dots = carousel.querySelectorAll('.v-carousel__dot');
      const prevBtn = carousel.querySelector('.v-carousel__btn--prev');
      const nextBtn = carousel.querySelector('.v-carousel__btn--next');
      const slides = carousel.querySelectorAll('.v-carousel__slide');
      if (!track || !slides.length) return;

      const updateDots = () => {
        if (!dots.length) return;
        const scrollLeft = track.scrollLeft;
        const slideWidth = slides[0].offsetWidth + parseInt(getComputedStyle(track).gap || 0);
        const idx = Math.round(scrollLeft / slideWidth);
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      };

      let scrollTimer;
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateDots, 60);
      }, { passive: true });

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          const slideWidth = slides[0].offsetWidth + parseInt(getComputedStyle(track).gap || 0);
          track.scrollTo({ left: i * slideWidth, behavior: 'smooth' });
        });
      });

      const scrollBy = (dir) => {
        const slideWidth = slides[0].offsetWidth + parseInt(getComputedStyle(track).gap || 0);
        track.scrollBy({ left: dir * slideWidth, behavior: 'smooth' });
      };

      if (prevBtn) prevBtn.addEventListener('click', () => scrollBy(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => scrollBy(1));

      updateDots();
    });
  };

  // Pulse-hint on first spec chevron — dismiss permanently after first toggle
  const initPulseHint = () => {
    document.querySelectorAll('.v-component-grid:not([data-pulse-init])').forEach((grid) => {
      grid.setAttribute('data-pulse-init', '');
      const firstSpec = grid.querySelector('.v-component:first-child');
      if (!firstSpec) return;
      firstSpec.addEventListener('toggle', () => {
        grid.setAttribute('data-pulse-done', '');
      }, { once: true });
    });
  };

  const init = () => {
    reveal();
    initMarquee();
    initAccordion();
    initCarousel();
    initPulseHint();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Re-init en design mode (Shopify theme editor)
  document.addEventListener('shopify:section:load', init);
})();
